module.exports = __webpack_public_path__ + "img/fant_pack.cc109a0b.png";